import { Button, Form } from 'antd';
import { FormFooterContainer } from '../Styled/GlobalStyles';

export const FormFooter = ({
  searchDisabled,
  resetForm,
  submitText,
}: {
  searchDisabled?: boolean;
  resetForm?: any;
  submitText?: string;
}) => {
  return (
    <FormFooterContainer>
      <Button type='text' onClick={resetForm}>
        Clear Form
      </Button>
      <Form.Item style={{ float: 'right', width: '200px' }}>
        <Button
          type='primary'
          htmlType='submit'
          style={{ backgroundColor: searchDisabled ? '' : '#4f45c7', height: '40px' }}
          block
          disabled={searchDisabled}
        >
          {submitText ? submitText : 'Search'}
        </Button>
      </Form.Item>
    </FormFooterContainer>
  );
};
